import { Grid } from '@mui/material'
import Label from 'components/Label'
import React, { ReactNode } from 'react'
import { StyledBoxAssign, StyledDividerAssign as AssignLawyer } from './styles'

type FieldAssignProps = {
  name?: string
  children?: ReactNode
}

export const FieldAssign: React.FC<FieldAssignProps> = ({ name, children }) => {
  return (
    <>
      <Grid item xs={12} display='flex' justifyContent='center'>
        {(name || children) && <AssignLawyer />}
      </Grid>
      <Grid item xs={12}>
        <StyledBoxAssign>{children ? children : <Label text={name} />}</StyledBoxAssign>
      </Grid>
    </>
  )
}
